// extracted by mini-css-extract-plugin
export default {"productCard":"ProductCard_productCard__0WePI"};